import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// // INVOICES
// // // LIST ALL INVOICES
export const invoicesList = (params = { page: 1, filter: '', language: '' }) =>
	Http.get(`/invoices/fetch${serialize({ ...params, light: 1 })}`)
// // // GET INVOICES BY ID
// /invoices/{id} is shadowed by the public uuid route of the same URI; /detail is the staff one.
export const invoicesByID = (params = '') => Http.get(`/invoices/${params}/detail`)
// // // POST NEW INVOICES
export const newInvoices = (params = '') => Http.post('/invoices', params)
// // // UPDATE INVOICES
export const updateInvoices = (params = '') => Http.put(`/invoices/${params.id}`, params)
// // // UPDATE ONLY THE CUSTOMER/COMPANY DATA PRINTED ON THE RECEIPT
export const updateReceiptDetails = (id, params) =>
	Http.patch(`/invoices/${id}/receipt-details`, params)
// // // DELETE INVOICES
export const deleteInvoicesByID = (params = '') => Http.delete(`/invoices/${params.id}`)
// // // STATS INVOICES
export const invoicesStats = (params = { filter: '', language: '' }) =>
	Http.get(`/invoices/status-counts${serialize(params)}`)
// // // UPDATE INVOICE STATUS
export const updateInvoiceStatus = (id, params) => Http.patch(`/invoices/${id}/status`, params)
// // // SEND PAYMENT LINK EMAIL
export const sendPaymentLink = (id) => Http.post(`/invoices/${id}/send-payment-link`)
// // // DOWNLOAD RECEIPT PDF
export const downloadReceipt = (id) =>
	Http.get(`/invoices/${id}/receipt`, { responseType: 'blob' })
// // // RENDER THE RECEIPT FOR AN UNSAVED DRAFT (nothing is persisted)
export const previewReceiptHtml = (params = {}) =>
	Http.post('/invoices/preview-receipt', params, { responseType: 'text' })
// // // RENDER RECEIPT HTML (live, always fresh — no caching)
export const renderReceiptHtml = (id) =>
	Http.get(`/invoices/${id}/render-receipt`, { responseType: 'text' })
// // // RESEND RECEIPT EMAIL
export const resendReceipt = (id) => Http.post(`/invoices/${id}/receipt/resend`)
// // // GENERATE RECEIPT PDF (queue without email)
export const generateReceipt = (id) => Http.post(`/invoices/${id}/receipt/generate`)
